import { render } from "./footer.vue?vue&type=template&id=557de9a9"
import script from "./footer.vue?vue&type=script&lang=js"
export * from "./footer.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__